import { useEffect, useState } from "react";
import type { TimerState } from "@quizshow/protocol";

export function Timer({ timer }: { timer: TimerState }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (timer.status !== "running") return;
    const id = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(id);
  }, [timer.status]);
  const milliseconds =
    timer.status === "running" && timer.deadlineAt
      ? Math.max(0, Date.parse(timer.deadlineAt) - now)
      : timer.status === "expired"
        ? 0
        : timer.durationMs;
  const totalSeconds = Math.ceil(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return (
    <div className={`timer timer--${timer.status}`}>
      <span className="timer__label">Timer</span>
      <strong>
        {minutes}:{seconds.toString().padStart(2, "0")}
      </strong>
    </div>
  );
}

